/*
 * Shared theme utilities. Loaded with `defer` BEFORE any component script
 * that consumes them, so they are available by the time component class
 * code runs.
 *
 * Exposed as window.OrdoUtils.* — keep this object stable; many components
 * delegate to it.
 */
(function () {
	if ( window.OrdoUtils ) return;

	/**
	 * Serialize a <form> into application/x-www-form-urlencoded format.
	 * Skips disabled, file, reset, submit, and button inputs. Honours
	 * `select-multiple` and unchecked checkboxes/radios.
	 */
	function serializeForm(form) {
		const arr = [];
		Array.prototype.slice.call(form.elements).forEach(function (field) {
			if (
				!field.name ||
				field.disabled ||
				['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
			) return;
			if (field.type === 'select-multiple') {
				Array.prototype.slice.call(field.options).forEach(function (option) {
					if (!option.selected) return;
					arr.push(
						encodeURIComponent(field.name) +
						'=' +
						encodeURIComponent(option.value)
					);
				});
				return;
			}
			if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
			arr.push(
				encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
			);
		});
		return arr.join('&');
	}

	/**
	 * Parse an HTML response text into a Document. Used when fetching
	 * `?section_id=…` to extract a section's innerHTML.
	 */
	function parseHTML(text) {
		return new DOMParser().parseFromString(text, 'text/html');
	}

	window.OrdoUtils = {
		serializeForm: serializeForm,
		parseHTML: parseHTML,
	};
})();
